import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

const MOBILE_BREAKPOINT = 700;

@Injectable({ providedIn: 'root' })
export class ResponsiveService {

  private isMobile$$ = new BehaviorSubject<boolean>(this.computeIsMobile());

  constructor(private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize')
        .pipe(debounceTime(150))
        .subscribe(() => {
          const next = this.computeIsMobile();
          if (next !== this.isMobile$$.value) {
            this.ngZone.run(() => this.isMobile$$.next(next));
          }
        });
    });
  }

  isMobile$: Observable<boolean> = this.isMobile$$.pipe(distinctUntilChanged());

  isMobile(): boolean {
    return this.isMobile$$.value;
  }

  private computeIsMobile(): boolean {
    return typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;
  }
}
